export enum SkuFormulaType {
  buyCost = "buyCost",
  supplier = "supplier",
  purchaseDate = "purchaseDate",
  salesRank = "salesRank",
  listPrice = "listPrice",
  asin = "asin",
  condition = "condition",
  custom = "custom",
  count = "count",
}
export type SkuFormulaItem = {
  type: SkuFormulaType;
  label: string;
  string?: string; /* when type === 'custom', string is provided */
  error?: boolean; //true if the the custom string has errors.
};
export type SkuFormula = SkuFormulaItem[];

export const MockFormula: SkuFormula = [
  {
    type: SkuFormulaType.asin,
    label: "ASIN",
  },
  {
    type: SkuFormulaType.condition,
    label: "Condition",
  },
  {
    type: SkuFormulaType.count,
    label: "Count",
  },
];
export const AllFormulaOptions: SkuFormulaItem[] = [
  {
    type: SkuFormulaType.buyCost,
    label: "Buy Cost",
  },
  {
    type: SkuFormulaType.supplier,
    label: "Supplier",
  },
  {
    type: SkuFormulaType.purchaseDate,
    label: "Purchase date",
  },
  {
    type: SkuFormulaType.salesRank,
    label: "Sales rank",
  },
  {
    type: SkuFormulaType.listPrice,
    label: "List price",
  },
  {
    type: SkuFormulaType.asin,
    label: "ASIN",
  },
  {
    type: SkuFormulaType.condition,
    label: "Condition",
  },
  {
    type: SkuFormulaType.count,
    label: "Count",
  },
  {
    type: SkuFormulaType.custom,
    label: "Custom",
  },
];

export const formulaTypeToString = (type: SkuFormulaType) => {
    switch (type) {
      case SkuFormulaType.buyCost:
        return "Buy cost";
      case SkuFormulaType.supplier:
        return "Supplier";
      case SkuFormulaType.purchaseDate:
        return "Purchase date";
      case SkuFormulaType.salesRank:
        return "Sales rank";
      case SkuFormulaType.listPrice:
        return "List price";
      case SkuFormulaType.asin:
        return "ASIN";
      case SkuFormulaType.condition:
        return "Condition";
      case SkuFormulaType.count:
        return "Count";
      case SkuFormulaType.custom:
        return "Custom"
    }
  };

export const makePreviewFormulaName = (formula: SkuFormula) => {
  let s = "";
  for (let i = 0; i < formula.length; i++) {
    const type = formula[i].type;
    switch (type) {
      case SkuFormulaType.buyCost:
        s += `${3050}`;
        break;
      case SkuFormulaType.supplier:
        s += "Walmart";
        break;
      case SkuFormulaType.purchaseDate:
        s += "10/14/2024";
        break;
      case SkuFormulaType.salesRank:
        s += "7";
        break;
      case SkuFormulaType.listPrice:
        s += "305";
        break;
      case SkuFormulaType.asin:
        s += "1633433";
        break;
      case SkuFormulaType.condition:
        s += "New";
        break;
      case SkuFormulaType.count:
        s += "1";
        break;
      case SkuFormulaType.custom:
        s += formula[i].string;
        break;
    }
    if (i !== formula.length - 1) s += "-";
  }
  return s;
};
